export default "images/social.svg";